import { LicenseDetailsBuyField, BillingLicenseDetailsField } from "./ParametersEnum";

export const InvalidNumbers = [
    LicenseDetailsBuyField.VALIDITY,
    LicenseDetailsBuyField.USER_CAPACITY,
    BillingLicenseDetailsField.USER_CAPACITY,
]